// extracted by mini-css-extract-plugin
export default {"agent":"Agent_agent__i0Lww","company":"Agent_company__f6eW9","companyNameReadOnly":"Agent_companyNameReadOnly__FEUgL","readOnlyIcon":"Agent_readOnlyIcon__RLImC"};